

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

import vSelect from "vue-select"
import { Team, Permission } from "@/types"

import { CurrentUser } from "@/types/user"
import { TenantFeatures } from "@/types/tenantFeatures"

const setup = namespace("setup")

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class FieldPermissions extends Vue {
	@Prop()
	public value: any;

	@Prop()
	public fieldPermissions: any;

	@Prop()
	public edit!: boolean;

	@Prop()
	public disabled!: boolean;

	@Prop({ default: null })
	public requiredValues!: Permission | null

	@Prop({ type: String, default: "" })
	public requiredValueTooltip!: string;

	@setup.Getter("getTeams")
	teams!: Team[];

	@Getter getIsFeatureEnabled!: (feature: TenantFeatures) => boolean

	recordEdit: boolean = true;

	@Watch("value")
	public valueChanged (newValue: any) {
		if (this.fieldPermissions) {

		} else {
			if (!newValue.view) {
				newValue.view = []
			}
			if (!newValue.edit) {
				newValue.edit = []
			}
		}
	}

	public viewSelectionChanged (newValue: any) {
		this.$emit("input", {
			view: newValue,
			edit: this.value.edit
		})
	}
	public editSelectionChanged (newValue: any) {
		this.$emit("input", {
			view: this.value.view,
			edit: newValue
		})
	}

	public displayTeams (teams: Team[]): string {
		if (teams.length === 0) {
			return "Any"
		}

		return teams.map(t => t.title).join(", ")
	}

	private overrideDefaults () {
		this.$emit("input", {
			view: this.fieldPermissions.view,
			edit: this.fieldPermissions.edit
		})
	}

	private clearOverride () {
		this.$emit("input", null)
	}

	public viewTeamRequired (teamId: string): boolean {
		return this.requiredValues
			? this.requiredValues.view!.some(team => team.id === teamId)
			: false
	}

	public editTeamRequired (teamId: string): boolean {
		return this.requiredValues
			? this.requiredValues.edit!.some(team => team.id === teamId)
			: false
	}

	private get closeOnSelect ():boolean {
		return !(this.getIsFeatureEnabled(TenantFeatures.MultiSelectKeepOpen))
	}
}

